import type { QueryParam } from "@ceeferenderer/itg-renderer-sdk";
import { transform } from "./transform";
import { handleResponse } from "./handleResponse";
import { trackPage } from "../utils/trackPage";
import { itgExecution } from "./itgExecution";
import { authInfo } from "../utils/authInfo";
import type { LoginResponse } from "@dotcom/oauthjs";

export const process = async (data?: Partial<QueryParam>): Promise<void> => {
  const loginResponse: LoginResponse = await authInfo;
  const response = await transform(data, loginResponse.accessToken);
  handleResponse(response, loginResponse);
  itgExecution.bindEvent();
  trackPage();
};
